<template>
  <div :style="OnVerStyle" class="OnlineVerifed">
    <div v-show="AppList.length <= 0" class="NoMoreInfo">
      暂无信息
    </div>
    <mu-container ref="container" class="loadmore-content">
      <mu-load-more :refreshing="refreshing" :loading="loading" :loaded-all="IsLoadAll" @load="LoadMore">
        <mu-list>
          <template v-for="item in getAppList">
            <mu-list-item :ripple="false" :key="item.Id" avatar button @click="OpenAppDet(item)">
              <mu-list-item-action>
                <mu-avatar>
                  <img :src="item.Avatar">
                </mu-avatar>
              </mu-list-item-action>
              <mu-list-item-title>{{ item.TrueName }}</mu-list-item-title>
              <mu-list-item-action>
                <mu-icon value="info"/>
              </mu-list-item-action>
            </mu-list-item>
            <mu-divider :key="item.Id"/>
          </template>
        </mu-list>
      </mu-load-more>

    </mu-container>

    <mu-container>
      <mu-dialog :open.sync="ShowDet" title="申请信息审核" width="360">
        <div>姓名：{{ SeledItem.TrueName }}</div>
        <div>电话：{{ SeledItem.Mobile }}</div>
        <div>单位：{{ SeledItem.CompName }}</div>
        <mu-button slot="actions" flat color="primary" @click="Verify">拒绝申请</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowDet = !ShowDet">取消</mu-button>
      </mu-dialog>
    </mu-container>

    <mu-container>
      <mu-dialog :open.sync="ShowMark" title="拒绝原因" width="360">
        <mu-text-field v-model="VerifyMark" :rows-max="6" placeholder="拒绝原因" multi-line/>
        <mu-button slot="actions" flat color="primary" @click="VerifyRef">确定</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowMark = !ShowMark">取消</mu-button>
      </mu-dialog>
    </mu-container>
  </div>
</template>

<script>
import { GetOnlineVeredList, OnlineVerify } from '../../../api/all'
import Toast from 'muse-ui-toast'
export default {
  name: 'OnlineVerifed',
  data() {
    return {
      OnVerStyle: {
        height: (window.innerHeight - 234) + 'px'
      },
      refreshing: false,
      loading: false,
      IsLoadAll: false,
      AppList: [],
      Pages: {
        PageIndex: 1,
        PageSize: 15,
        Total: 0
      },
      ShowDet: false,
      SeledItem: {},
      ShowMark: false,
      VerifyMark: ''
    }
  },
  computed: {
    getAppList() {
      return this.AppList
    }
  },
  methods: {
    GetAppList: function(PageIndex, PageSize) {
      this.loading = true
      this.IsLoadAll = false
      this.AppList = []
      this.Pages.PageIndex = 1
      this.PageSize = 15
      GetOnlineVeredList(PageIndex, PageSize).then(res => {
        // console.log(res.data)
        if (res.data.AppList.length > 0) {
          res.data.AppList.forEach(item => {
            this.AppList.push(item)
          })
          if (this.AppList.length === res.data.Total) {
            this.IsLoadAll = true
          }
        }
        this.$emit('SetWaitVeredNum', 3, res.data.Total)
        this.loading = false
      })
    },
    LoadMore: function() {
      this.loading = true
      var Index = this.Pages.PageIndex + 1
      this.Pages.PageIndex = Index
      var Size = this.Pages.PageSize
      GetOnlineVeredList(Index, Size).then(res => {
        if (res.data.AppList.length > 0) {
          res.data.AppList.forEach(item => {
            this.AppList.push(item)
          })
        }
        if (this.AppList.length === res.data.Total) {
          this.IsLoadAll = true
        }
        this.loading = false
      })
    },
    OpenAppDet: function(item) {
      this.ShowDet = true
      this.SeledItem = {}
      this.SeledItem = Object.assign(item)
    },
    Verify: function() {
      this.ShowDet = false
      this.ShowMark = true
    },
    VerifyRef: function() {
      OnlineVerify(this.SeledItem.Id, 2, this.VerifyMark).then(res => {
        if (res.error !== 0) {
          Toast.error(res.msg)
        } else {
          Toast.success(res.msg)
        }
        this.ShowDet = false
        this.ShowMark = false
        this.GetAppList()
      })
    }
  }
}
</script>

<style scoped>
.OnlineVerifed{
  width: 100%;
  display: flex;
  flex-direction: column;

}
.mu-appbar {
    width: 100%;
  }
.loadmore-content {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.NoMoreInfo{
  text-align: center;
  width: 100%;
  margin-top: 50px;
  font-size: 25px;
  color: rgb(120, 120, 120)
}
</style>



// WEBPACK FOOTER //
// src/view/Login/components/OnlineVered.vue